<template>
  <v-list class="pa-0">
    <v-list-item
      v-for="(item, index) in breakfasts"
      :key="item.breakfastId || index"
      class="border-bottom px-4" 
    >
      <div class="d-flex align-start justify-space-between w-100 py-3">

        <div class="flex-grow-1" style="min-width: 0;">
          <p class="mb-0" style="white-space: pre-wrap; word-break: break-all;">
            {{ item.content }}
          </p>
        </div>

        <div class="d-flex flex-shrink-0 pr-1">
          <v-btn
            icon
            variant="text"
            color="green"
            density="comfortable"
            @click="openEditDialog(item)"
          >
            <v-icon>mdi-pencil</v-icon>
          </v-btn>

          <v-btn
            icon
            variant="text"
            color="red"
            density="comfortable"
            @click="deleteItem(item)"
          >
            <v-icon>mdi-delete</v-icon>
          </v-btn>
        </div>
      </div>
    </v-list-item>

    <v-dialog v-model="isBreakfastDialog">
      <breakfast-modal
        v-if="isBreakfastDialog"
        type="edit"
        :breakfastId="selectedItem?.breakfastId"
        :editContent="selectedItem?.content"
        :isOpen="isBreakfastDialog"
        :childId="childId"
        :selectedDate="selectedDate"
        @posted="edited"
        @close="isBreakfastDialog = false"
      />
    </v-dialog>
  </v-list>
</template>
<script lang="ts">
import Vue from 'vue';
import { defineComponent } from 'vue';
import Swal from 'sweetalert2';
import dayjs from 'dayjs';
import 'dayjs/locale/ja';
dayjs.locale('ja');

import { dailyReportModule } from '@/store/entityModules/dailyReport';

import { BreakfastResponse } from '@API/src/component/home/breakfast/types';
/*
import {
  SwipeList,
  SwipeOut,
} from 'vue-swipe-actions';
 */
import { Toast } from '@/service/SweetAlert';
//import 'vue-swipe-actions/dist/vue-swipe-actions.css';
import { SwipeListModel } from '@/model/SwipeList/SwipeList';
import BreakfastModal from '@/components/modal/BreakfastModal.vue';

interface DataType {
  isBreakfastDialog: boolean;
  selectedItem: any;
}

export default defineComponent({

  components: {
    //SwipeOut,
    //SwipeList,
    BreakfastModal,
  },

  props: {
    breakfasts: {
      type: Array,
      default: () => ([]),
    },
    childId: {
      type: Number,
      default: NaN,
    },
    selectedDate: {
      type: String,
      default: dayjs().format('YYYY-MM-DD'),
    },
  },

  computed: {
    swipeList(): SwipeListModel {
      return (this.$refs as any).breakfast_swipe_list;
    },
  },

  data: (): DataType =>({
    isBreakfastDialog: false,
    selectedItem: null as any,
  }),
  methods: {
    openEditDialog(item) {
      this.selectedItem = item;
      this.isBreakfastDialog = true;
    },
    minuteFormat(iso: string) {
      return dayjs(iso).format('HH:mm');
    },
    revealFirstRight(index, revealed) {
      if (!revealed) {
        this.swipeList.revealRight(index);
      } else {
        this.swipeList.closeActions(index);
      }
    },
    revealFirstLeft() {
      this.swipeList.revealLeft(0);
    },
    closeFirst() {
      this.swipeList.closeActions(0);
    },
    closeAll() {
      this.swipeList.closeActions();
    },
    async deleteItem(e: BreakfastResponse) {
      Swal.fire({
        title: '<span style="font-size: 23px;">記録を削除しますか?</span>',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#FF3F3A',
        cancelButtonColor: '#BDBDBD',
        confirmButtonText: '削除',
        cancelButtonText: 'キャンセル',
      }).then(async (result) => {
        if (result.isConfirmed) {
          Swal.showLoading();
          await dailyReportModule.deleteBreakfast({ breakfastId: e.breakfastId });
          Toast.fire({
            icon: 'success',
            title: '削除が完了しました',
          });
        }
      });
    },
    edited() {
      Toast.fire({
        icon: 'success',
        title: '変更が完了しました',
      });
      this.$emit('edited');
    },
    itemClick(e) {},
    fbClick(e) {},
    sbClick(e) {},
  },

});
</script>
<style lang="scss" scoped>

</style>
<style scoped>
.border-bottom {
  border-bottom: 1px solid #eee;
}
.w-100 {
  width: 100%;
}
</style>
